import React from 'react';
import './Footer.css';
import 'boxicons/css/boxicons.min.css';
import logo from '../assets/img/logo.png'; // Make sure the path is correct

const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            {/* About/Contact Section */}
            <div className="col-lg-4 col-md-6 footer-contact">
              {/* Add the logo here */}
              <img src={logo} alt="abp big bags logo" className="footer-logo" />
              <p>
                1103 Budapest<br />
                Gyömroi ut 115<br />
                Hungary <br /><br />
                <strong>Phone:</strong> +36 70 657 61-99<br />
                <strong>Email:</strong> info@abpbigbag.com<br />
              </p>
            </div>
            {/* Useful Links Section */}
            <div className="col-lg-4 col-md-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                {/* Use React Router Link component if applicable */}
                <li><i className="bx bx-chevron-right"></i> <a href="/">Home</a></li>
                <li><i className="bx bx-chevron-right"></i> <a href="/about">About us</a></li>
                <li><i className="bx bx-chevron-right"></i> <a href="/sectors">Sectors</a></li>
                <li><i className="bx bx-chevron-right"></i> <a href="#">Terms of service</a></li>
                <li><i className="bx bx-chevron-right"></i> <a href="#">Privacy policy</a></li>
              </ul>
            </div>
            {/* Products/Services Section */}
            <div className="col-lg-4 col-md-6 footer-links">
              <h4>Our Products</h4>
              <ul>
                 {/* Link to main product categories or specific products */}
                <li><i className="bx bx-chevron-right"></i> <a href="/products/big-bag">Big Bag</a></li>
                <li><i className="bx bx-chevron-right"></i> <a href="/products/sacks">Sacks</a></li>
                <li><i className="bx bx-chevron-right"></i> <a href="/products/pe-film">PE Film</a></li>
                <li><i className="bx bx-chevron-right"></i> <a href="/products/twines">Twines</a></li>
                <li><i className="bx bx-chevron-right"></i> <a href="/products/special">Special Products</a></li>
              </ul>
            </div>
            {/* Social Network Section has been removed */}
          </div>
        </div>
      </div>
      <div className="container footer-bottom clearfix">
        <div className="copyright">
          &copy; Copyright {new Date().getFullYear()} <strong><span>ABP Big Bags</span></strong>. All Rights Reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;